import { render, staticRenderFns } from "./DaftarPenarikan.vue?vue&type=template&id=200e94ed&"
import script from "./DaftarPenarikan.vue?vue&type=script&lang=js&"
export * from "./DaftarPenarikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports